import { createFileRoute } from '@tanstack/react-router'
import { SupplierImportPage } from "@/components/pages/inventory/purchase-order/supplier-import/page";

export const Route = createFileRoute(
  '/_app/inventory/purchase-order/supplier-import/page',
)({
  component: SupplierImportPage,
})
